// Priority:
//   1. Runtime override injected in public/index.html  (window.__APP_CONFIG__.BASE_URL)
//   2. Build-time env variable                         (REACT_APP_BASE_URL in .env.local / CI)
//   3. Ambiente.local.js                               (local dev fallback, not committed to prod)
//   4. Ambiente.js                                     (production default)
const _ambienteDefault =
  process.env.NODE_ENV === 'development'
    ? require('./Ambiente.local.js').default
    : require('./Ambiente.js').default;

const URLBASE =
  (typeof window !== 'undefined' && window.__APP_CONFIG__ && window.__APP_CONFIG__.BASE_URL) ||
  process.env.REACT_APP_BASE_URL ||
  _ambienteDefault;

export { URLBASE };
export const LOCALE = 'es-AR';
export const URLLOGIN = URLBASE + '/login';
export const URLLOGOUT = URLBASE + '/logout';

export const ORDEN_TECNICOS = 90;
